import * as React from "react";
import { createContext, useContext } from "react";
import { User } from "@linkfluence/models/user";

const UserContext = createContext<User>(null);

export function useUser() {
  return useContext(UserContext);
}

interface IProps {
  children: React.ReactNode;
  user: User;
}

export const UserProvider = ({ children, user }: IProps) => {
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
